import { render } from "./PalmAndTreesModule.vue?vue&type=template&id=3671962e&scoped=true"
import script from "./PalmAndTreesModule.vue?vue&type=script&lang=js"
export * from "./PalmAndTreesModule.vue?vue&type=script&lang=js"

import "./PalmAndTreesModule.vue?vue&type=style&index=0&id=3671962e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3671962e"

export default script